export default __webpack_public_path__ + "static/media/2324 utensils top.63dcdba7.png";